import AppBar from '../AppBar/AppBar';

const Layout = () => {
  return <AppBar />;
};

export default Layout;
